import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';
import {DisplayOnlyTable} from 'shells/table/display-only-table';

import type {GetAgents_chatAgents as Agent} from 'nutshell-graphql-types';

import {SettingsSidebar} from '../../../../setup/settings-sidebar';

import {useGetAgents} from '../../graphql/hooks';

import {buildOpenChatAssigneeUrl} from '../helpers';

import {AgentStatusTableEntry} from './agent-status-table-entry';
import {NeedsReplyPill} from './needs-reply-pill';

import styles from './agent-settings-table.module.css';

export function AgentSettingsTable() {
    const {chatAgents, error, isLoading} = useGetAgents();

    const columns = React.useMemo(
        () => [
            {
                id: 'name',
                Header: 'Agent',
                accessor: (chatAgent: Agent) => chatAgent,
                dataType: 'linkedEntity',
                hasLeftBorder: true,
            },
            {
                id: 'status',
                Header: 'Status',
                accessor: (chatAgent: Agent) => chatAgent,
                Cell: ({cell}: any) => {
                    const chatAgent = cell.value;

                    return <AgentStatusTableEntry agent={chatAgent} />;
                },
                dataType: 'string',
            },
            {
                id: 'openChats',
                Header: 'Open chats',
                accessor: (chatAgent: Agent) => chatAgent,
                Cell: ({cell}: any) => {
                    const chatAgent = cell.value;

                    return (
                        <StackLegacy spacing={6} alignCenter={true} isHorizontal={true}>
                            {chatAgent.numNeedsReplyChats > 0 && (
                                <NeedsReplyPill agent={chatAgent} />
                            )}
                            <Link
                                // @ts-expect-error
                                as={RoutedLink}
                                variant='primary'
                                size='small'
                                to={buildOpenChatAssigneeUrl(chatAgent.id)}
                            >
                                {chatAgent.numActiveChats}
                            </Link>
                        </StackLegacy>
                    );
                },
                dataType: 'string',
                hasRightBorder: true,
            },
        ],
        []
    );

    if (isLoading && !chatAgents) {
        return null;
    }

    return (
        <div className={styles['agents-table-container']}>
            <DisplayOnlyTable
                // @ts-expect-error
                columns={columns}
                data={chatAgents || []}
                isLoading={false}
                error={error}
                disableSorting={true}
                emptyStateText='No agents found'
                emptyStateSubtitle={
                    <>
                        {/* @ts-expect-error */}
                        <Link variant='primary' as={RoutedLink} to='/setup/user'>
                            Assign Engagement licenses{' '}
                        </Link>
                        to users to get started
                    </>
                }
            />
            <div>
                <SettingsSidebar glossaryKey='/inbox/settings/agents' />
            </div>
        </div>
    );
}
